import { AdminCertificatesSettingsModalHeaderProps } from "../../../../models/admin-certificates-settings.models";
import { XMarkIcon } from "@heroicons/react/24/outline";

const AdminCertificatesSettingsModalHeader = ({ row, saving, onCancel }: AdminCertificatesSettingsModalHeaderProps) => (
  <header className="flex items-start justify-between gap-4 border-b border-gray-200 px-5 py-3 dark:border-gray-700">
    <div className="min-w-0">
      <h2
        id="admin-certificates-settings-modal-title"
        className="truncate text-xl font-semibold text-black dark:text-white"
        data-test="admin-certificates-settings-modal-subtitle"
      >
        {row.CERTIFICATE_NAME ?? "Unnamed certificate"}
      </h2>
    </div>
    <button
      type="button"
      aria-label="Close certificates settings modal"
      title="Close"
      data-test="admin-certificates-settings-modal-close"
      disabled={saving}
      className="flex h-9 w-9 flex-none items-center justify-center border border-gray-300 text-gray-500 hover:text-green disabled:opacity-50 dark:border-gray-700"
      onClick={onCancel}
    >
      <XMarkIcon className="h-5 w-5" />
    </button>
  </header>
);

export default AdminCertificatesSettingsModalHeader;
